<template>
  <div >
    <b-container>
      <b-row>
        <Login class="marginal"/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/Login.vue';
import Register from '@/components/Register.vue';
export default {
  name: 'auth',
  components: {
    Login,
    Register
  }
}
</script>